import React from 'react';

import { makeStyles, Theme } from '@material-ui/core/styles';
import clsx from 'clsx';

import { Typography } from '../../atoms';

export interface SectionGroupProps {
  children: React.ReactNode;
  className?: string;
  icon?: JSX.Element;
  sectionName?: string;
  title: string;
  titleSecondary?: JSX.Element;
}

const useStyles = makeStyles((theme: Theme) => ({
  sectionContent: {
    borderLeft: 'none',
    margin: 0,
    padding: 0,
    paddingBottom: theme.spacing(3.5),

    '& .MuiFormControl-root': {
      padding: 0,
    },
    '& .MuiFormGroup-root': {
      padding: 0,
    },
  },

  sectionTitleContainer: {
    alignItems: 'center',
    display: 'flex',
    flexFlow: 'row nowrap',
    justifyContent: 'space-between',
    marginBottom: theme.spacing(2.2),
    marginTop: theme.spacing(1.2),
  },

  sectionTitle: {
    display: 'inline-flex',

    '& .fd-text__h2': {
      paddingLeft: theme.spacing(1.25),
    },
  },

  sectionWrapper: {
    marginLeft: theme.spacing(2),
    marginRight: theme.spacing(2),
  },

  [theme.breakpoints.up('md')]: {
    sectionWrapper: {
      margin: 0,
    },

    sectionContent: {
      borderLeft: `2px dashed ${theme.palette.grey[200]}`,
      marginLeft: theme.spacing(1.5),
      padding: theme.spacing(0, 0, 7.75, 4.375),
    },

    sectionTitle: {
      '& .MuiTypography-h2': {
        lineHeight: 1,
        paddingLeft: theme.spacing(3),
      },
    },
  },
}));

export function SectionGroup(props: SectionGroupProps): JSX.Element {
  const {
    children,
    className,
    icon = null,
    sectionName = '',
    title,
    titleSecondary = null,
  } = props;
  const classes = useStyles();

  const sectionIdentifierClassName = sectionName
    ? `fd-section__${sectionName.toLowerCase()}`
    : null;

  const sectionGroupStyles = clsx(
    'fd-section',
    sectionIdentifierClassName,
    classes.sectionWrapper,
    className && className,
  );

  const sectionContentStyles = clsx(
    classes.sectionContent,
    'fd-section__panel',
    className && `${className}-content`,
  );

  return (
    <div className={sectionGroupStyles}>
      <div className={classes.sectionTitleContainer}>
        <div className={classes.sectionTitle}>
          {icon}
          <Typography variant="h2">{title}</Typography>
        </div>

        {titleSecondary}
      </div>

      <div className={sectionContentStyles}>{children}</div>
    </div>
  );
}
